import * as yup from 'yup';

const ReviewFormValidationSchema = yup.object().shape({
  newNotes: yup.string().max(160, 'Notes must be max 160 characters.'),
});

export default ReviewFormValidationSchema;
